import { render } from "./index.vue?vue&type=template&id=53027786&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "@/style/manga-list.less?vue&type=style&index=0&id=53027786&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53027786"],['__file',"src/views/last-read/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53027786"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53027786', __exports__)) {
    console.log('reload')
    api.reload('53027786', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=53027786&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('53027786', render)
  })

}


export default __exports__